import React from 'react'

import { Picture } from 'Picture'

interface TableItemPictureProps {
  nextGenImage: '*.webp'
  fallbackImage: string
  altText: string
}

export const TableItemPicture = ({
  nextGenImage,
  fallbackImage,
  altText,
}: TableItemPictureProps) => (
  <Picture
    sourcesMatrix={[[{ srcSet: nextGenImage, type: 'image/webp' }, { srcSet: fallbackImage }]]}
    image={{ src: fallbackImage, alt: altText }}
  />
)
